import { query, getDocs, limit, startAfter, orderBy } from 'firebase/firestore'
import firestore from '../../firestore'
import { CompanyPayment } from '@leadgen/models/client'
import BaseService from '../BaseService'

class CompanyPaymentService extends BaseService {
  readonly pageSize = 50
  fetchCompanyPayments = async ({
    companyId,
  }: {
    companyId: string
  }): Promise<CompanyPayment[]> => {
    const companyPaymentsSnapshot = await getDocs(firestore.companyPayments(companyId))
    return companyPaymentsSnapshot.docs.map(companyPaymentDoc => companyPaymentDoc.data())
  }
  fetchCompanyPaymentsFirstPage = async ({
    companyId,
    onCompanyPaymentAdded,
    onCompanyPaymentUpdated,
  }: {
    companyId: string
    onCompanyPaymentAdded: (template: CompanyPayment) => void
    onCompanyPaymentUpdated: (template: CompanyPayment) => void
  }) => {
    const { data, unsubscribe } = await this.onSnapshot({
      query: query(
        firestore.companyPayments(companyId),
        orderBy('datePaid', 'desc'),
        limit(this.pageSize),
      ),
      onAdded: onCompanyPaymentAdded,
      onUpdated: onCompanyPaymentUpdated,
    })
    return {
      data,
      unsubscribe,
    }
  }
  fetchCompanyPaymentsNextPage = async ({
    companyId,
    startAfter: startAfterTimestamp,
    onCompanyPaymentUpdated,
  }: {
    companyId: string
    startAfter: Date
    onCompanyPaymentUpdated: (template: CompanyPayment) => void
  }) => {
    const { data, unsubscribe } = await this.onSnapshot({
      query: query(
        firestore.companyPayments(companyId),
        orderBy('datePaid', 'desc'),
        startAfter(startAfterTimestamp),
        limit(this.pageSize),
      ),
      onUpdated: onCompanyPaymentUpdated,
    })
    return {
      data,
      unsubscribe,
    }
  }
}

export default new CompanyPaymentService()
